import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-triangle-down",
  "use": "icon-icon-arrow-triangle-down-usage",
  "viewBox": "0 0 8.6 6.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8.6 6.5\" id=\"icon-icon-arrow-triangle-down\">\n<polyline points=\"3.8,0 0,0 4.3,6.5 8.6,0 4.8,0 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol